var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"js-photo"})}
var staticRenderFns = []

export { render, staticRenderFns }